import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("arc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const fmtNGN = (n) =>
  "₦" + Number(n || 0).toLocaleString("en-NG", { maximumFractionDigits: 0 });
export const fmtUSD = (n) =>
  "$" + Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const tierFor = (price) => {
  const p = Number(price || 0);
  if (p >= 750000) return "Platinum";
  if (p >= 250000) return "Premium";
  if (p >= 50000) return "Classic";
  return "Basic";
};

export const tierStyle = (tier) =>
  ({
    Platinum: "bg-slate-800 text-white",
    Premium: "bg-gold text-white",
    Classic: "bg-sky-600 text-white",
    Basic: "bg-secondary text-muted-foreground",
  }[tier] || "bg-secondary text-muted-foreground");

// Image loading strategy for reliable cross-origin display across all browsers:
// - Wikimedia (upload.wikimedia.org) is loaded DIRECTLY — served with permissive CORP and
//   handled from each user's own IP (fast, no central rate-limiting).
// - artic.edu / metmuseum.org set restrictive Cross-Origin-Resource-Policy that some browsers
//   block (ERR_BLOCKED_BY_RESPONSE.NotSameOrigin), so those go through our SAME-ORIGIN proxy.
export const img = (url) => {
  if (!url) return url;
  if (url.includes("artic.edu") || url.includes("metmuseum.org")) {
    return `${API}/image-proxy?url=${encodeURIComponent(url)}`;
  }
  return url;
};
